import React from "react"

import labelClasses from "./labelClasses"

export const CustomerInfoFieldset = ({
  bindContactName,
  bindPhoneNumber,
  bindEmailAddress,
  formErrors,
}) => {
  const contactNameClasses = labelClasses(formErrors.contactName)
  const emailAddressClasses = labelClasses(formErrors.emailAddress)

  return (
    <fieldset>
      <p>Please enter your contact details to receive confirmation.</p>

      <div className="input">
        <label htmlFor="contact-name" className={contactNameClasses}>
      Contact Name
        </label>
        <input type="text" maxLength="36" {...bindContactName} />
        <small id='contact-name-error'>{formErrors.contactName}</small>
      </div>

      <div className="input">
        <label htmlFor="email-address" className={emailAddressClasses}>
      Email Address
        </label>
        <input type="text" {...bindEmailAddress} />
        <small>{formErrors.emailAddress}</small>
      </div>

      <div className="input">
        <label
          htmlFor="phone-number"
          className={formErrors.phoneNumber ? "label has-error" : "label"}
        >
      Phone Number
        </label>
        <input type="text" maxLength="10" {...bindPhoneNumber} />
        <small>{formErrors.phoneNumber}</small>
      </div>

    </fieldset>
  )
}

export default CustomerInfoFieldset
